import { Amplify } from 'aws-amplify';
import {
    getCurrentUser,
    signIn,
    fetchUserAttributes,
    fetchAuthSession,
    confirmSignIn,
    signOut,
    fetchMFAPreference,
    verifyTOTPSetup,
    updateMFAPreference,
} from '@aws-amplify/auth';
import { Promise } from 'core-js';
import config from '../../../aws-exports';
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

Amplify.configure({ ...config, authenticationFlowType: 'USER_PASSWORD_AUTH' });

const domain = process.env.VUE_APP_COOKIE_DOMAIN;

if (domain && window.location.href.indexOf(domain) > -1) {
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
        new CookieStorage({
            domain: domain,
            secure: false,
        })
    );
}

export default {
    async login({ commit }, { email, password }) {
        try {
            const { isSignedIn, userId, nextStep } = await signIn({
                username: email,
                password,
                options: {
                    authFlowType: 'USER_PASSWORD_AUTH',
                },
            });

            if (nextStep && nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
                const response = { code: -1, value: userId, success: true };
                return response;
            } else {
                const user = await getCurrentUser();
                const userAttributes = await fetchUserAttributes();
                const authSession = await fetchAuthSession();
                const groups =
                    authSession.tokens.idToken.payload && authSession.tokens.idToken.payload['cognito:groups']
                        ? authSession.tokens.idToken.payload['cognito:groups']
                        : [];
                commit('setCognitoUser', {
                    user: user,
                    attributes: userAttributes,
                    auth: {
                        accessToken: authSession.tokens.accessToken.toString(),
                        idToken: authSession.tokens.idToken.toString(),
                    },
                    groups: groups,
                });
                return { code: isSignedIn, success: true };
            }
        } catch (error) {
            console.log('error is ', error);
            return { success: false, error: error };
        }
    },
    async validateUserMFA({ commit }, { mfaCode }) {
        try {
            await confirmSignIn({ challengeResponse: mfaCode });
            //console.log(mfaPassedUser);
            const user = await getCurrentUser();
            const userAttributes = await fetchUserAttributes();
            const authSession = await fetchAuthSession();
            const groups =
                authSession.tokens.idToken.payload && authSession.tokens.idToken.payload['cognito:groups']
                    ? authSession.tokens.idToken.payload['cognito:groups']
                    : [];

            commit('setCognitoUser', {
                user: user,
                attributes: userAttributes,
                auth: {
                    accessToken: authSession.tokens.accessToken.toString(),
                    idToken: authSession.tokens.idToken.toString(),
                },
                groups: groups,
            });
        } catch (error) {
            //console.log(error);
            return error;
        }
    },
    async signOut({ commit }) {
        try {
            await signOut();
            commit('resetCognitoUser');
            window.location.href = '/login';
            const host = window.location.hostname;
            let domain = '';
            if (host.includes('clarityglobal')) {
                domain = host.slice(-17);
            } else {
                domain = host;
            }
            document.cookie =
                'rd_authenticated=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + domain + ';';
            return true;
        } catch (error) {
            console.log('error signing out: ', error);
            return false;
        }
    },
    async checkUserAuth({ commit }) {
        try {
            const user = await getCurrentUser();
            const userAttributes = await fetchUserAttributes();
            const authSession = await fetchAuthSession();
            const groups =
                authSession.tokens.idToken.payload && authSession.tokens.idToken.payload['cognito:groups']
                    ? authSession.tokens.idToken.payload['cognito:groups']
                    : [];
            commit('setCognitoUser', {
                user: user,
                attributes: userAttributes,
                auth: {
                    accessToken: authSession.tokens.accessToken.toString(),
                    idToken: authSession.tokens.idToken.toString(),
                },
                groups: groups,
            });
            return Promise.resolve({
                user: user,
                attributes: userAttributes,
                auth: {
                    accessToken: authSession.tokens.accessToken.toString(),
                    idToken: authSession.tokens.idToken.toString(),
                },
                groups: groups,
            });
        } catch {
            commit('setCognitoUser', false);
            return Promise.resolve(false);
        }
    },
    async storeNewUserEmail({ commit }, { email }) {
        commit('setNewUserEmail', email);
        return true;
    },
    async checkUserMFA({ commit }) {
        try {
            const output = await fetchMFAPreference();
            commit('setPreferredMFA', output.enabled ? output.enabled : []);
            return output.enabled;
        } catch (error) {
            console.log('error:' + error);
        }
    },
    async setupUserMFA({ commit }, { code }) {
        try {
            await verifyTOTPSetup({ code });
            await updateMFAPreference({ totp: 'ENABLED' });
            commit('setPreferredMFA', ['TOTP']);
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    },
    async updateUserMFA({ commit }, { type }) {
        console.log(type);
        try {
            const mfaValue = await updateMFAPreference({ totp: 'DISABLED' });
            commit('setPreferredMFA', []);
            return mfaValue;
        } catch (error) {
            console.log(error);
        }
    },
    async registrationStoreStageOne({ commit }, { data }) {
        commit('newUserStageOneData', data);
        return true;
    },
    async registrationStoreStageTwo({ commit }, { data }) {
        commit('newUserStageTwoData', data);
        return true;
    },
    async registrationStoreStageThree({ commit }, { data }) {
        commit('newUserStageThreeData', data);
        return true;
    },
    // async signupUser({commit}) {
    //   //commit('newUserID');
    //   return true;
    // }
    setTargetUUID({ commit }, uuid) {
        if (process.env.VUE_APP_TARGET_OVERRIDE === 'true') {
            commit('setTargetUUID', uuid);
        }
    },
    autoLogout({ commit }) {
        commit('didAutoLogout');
    },
    resetAutoLogout({ commit }) {
        commit('resetAutoLogout');
    },
};
